// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { Button } from "../../../revvComponents";

class showconvertFormDocToEditorDoc extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  _closePopup = () => {
    this.props.toggleModalPopUp("showconvertFormDocToEditorDoc", false);
  };

  _onConfirmation = () => {
    this.props.confirmAction();
    this._closePopup();
  };

  render() {
    return (
      <Modal open onClose={this._closePopup} closeOnOverlayClick={false} center>
        <div
          className="freeeditdocpopup-container"
          data-test="freeeditdocpopup-container">
          <div
            className="freeeditdocpopup-modal-heading"
            data-test="freeeditdocpopup-modal-heading">
            Are you sure you want to customize the document?
          </div>
          <div className="freeeditdocpopup-form">
            <div
              className="freeeditdocpopup-form-field"
              data-test="freeeditdocpopup-templatename">
              Once you customize this document, you will not see the form
              anymore. So, make sure you no longer need to use the form to fill
              the docment.
            </div>
          </div>
        </div>
        <div className="createquotepopup-footer popup-footer">
          <div className="footer-actions">
            <Button
              className="btn btn-transparent createquotepopup-footer-cancelbtn"
              data-test="createassetfolderpopup-template-cancel-button"
              onClick={this._closePopup}>
              Cancel
            </Button>
            <Button
              data-test="createassetfolderpopup-template-clonetemplate-button"
              onClick={this._onConfirmation}>
              Customize
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default showconvertFormDocToEditorDoc;
